import React, { useEffect, useState, useRef } from 'react';
import { FiChevronDown, FiSearch } from 'react-icons/fi';

const BankSelect = ({ banks, value, onChange, disabled }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);
  const searchRef = useRef(null);

  const selected = banks.find(b => b.bank_code === value);
  const filtered = banks.filter(b =>
    b.name.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    if (open) searchRef.current?.focus();
  }, [open]);

  const handleSelect = (bank) => {
    onChange(bank);
    setOpen(false);
    setSearch('');
  };

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen(o => !o)}
        className="flex items-center justify-between w-full rounded-xl bg-gray-50 border border-gray-200 px-4 py-2.5 text-sm focus:outline-none disabled:opacity-50"
      >
        <span className={selected ? 'text-gray-900' : 'text-gray-400'}>
          {selected ? selected.name : 'Select bank'}
        </span>
        <FiChevronDown className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white rounded-xl border border-gray-200 shadow-lg overflow-hidden">
          <div className="flex items-center gap-2 px-3 py-2 border-b border-gray-100">
            <FiSearch className="text-gray-400 shrink-0 text-sm" />
            <input
              ref={searchRef}
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search banks..."
              className="flex-1 text-sm bg-transparent border-none outline-none text-gray-700 placeholder-gray-400"
            />
          </div>
          <ul className="max-h-48 overflow-y-auto">
            {filtered.length === 0 ? (
              <li className="px-4 py-3 text-sm text-gray-400 text-center">No banks found</li>
            ) : filtered.map(bank => (
              <li
                key={bank.bank_code}
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleSelect(bank);
                }}
                className={`px-4 py-2.5 text-sm cursor-pointer hover:bg-indigo-50 ${
                  bank.bank_code === value ? 'bg-indigo-50 text-indigo-600 font-medium' : 'text-gray-700'
                }`}
              >
                {bank.name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BankSelect;
